<ion-header>
    <ion-toolbar>
        <ion-title mode="ios" role="heading">{{'STATUS_LD_SURVEY_STATUS' | translate}}</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="dismiss()">
                <ion-icon name="close-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    <ion-list>
        <ion-item *ngFor="let day of days" (click)="onClickDay(day)">
            <ion-label>{{ day.date }}</ion-label>
            <ion-badge color="participant">{{ day.incompleteCount }}</ion-badge>
            <ion-icon slot="end" name="chevron-forward"></ion-icon>
        </ion-item>
    </ion-list>

    <h6 *ngIf="days.length === 0" class="ion-text-center">
        {{ 'STATUS_LD_NO_SURVEYS' | translate }}
    </h6>

</ion-content>
